<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="$vuetify.lang.t('$vuetify.DASHBOARD.PLACES_TITLE')"
      :breadcrumbs="[
        {
          text: $vuetify.lang.t('$vuetify.DASHBOARD.PLACES_DESCRIPTION'),
          disabled: true
        }
      ]"
    ></BaseBreadcrumb>
    <!-- <v-col cols="12" md="4">
    </v-col> -->
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <searchbar>
              <v-btn v-if="isGlobalAdmin" color="success" text small>
                <v-icon class="mr-2">mdi-plus</v-icon>Add new location
              </v-btn>
            </searchbar>
            <v-data-table
              v-if="places.length > 0"
              :items="paginatedData"
              :headers="headers"
              class="overflow-y-auto"
              style="max-height: 60vh;"
              hide-default-footer
              :item-class="isChildItem"
            >
              <template
                v-for="(header, i) in headers"
                v-slot:[`header.${header.value}`]
              >
                <span v-if="header.i18n" :key="i">
                  {{ $vuetify.lang.t(`$vuetify.${header.i18n}`) }}
                </span>
                <span v-else-if="!header.i18n && header.text" :key="i">
                  {{ header.text }}
                </span>
              </template>
              <template v-slot:item="props">
                <tr :class="{ 'grey lighten-3': props.item.isChildPlace }">
                  <td>
                    <div style="width: 260px;">
                      <v-tooltip v-if="props.item.WithAdminRights" bottom>
                        <template v-slot:activator="{ on }">
                          <div
                            v-if="props.item.WithAdminRights"
                            :class="{
                              'primary--text': props.item.Type == 'PARKING',
                              'purple--text': props.item.Type == 'CAR_WASH'
                            }"
                            class="d-inline mr-2"
                            v-on="on"
                          >
                            {{ props.item.Type === 'PARKING' ? 'P' : 'W' }}
                          </div>
                        </template>
                        <span> ID={{ props.item.Id }} </span>
                      </v-tooltip>
                      {{ props.item.Name }}
                    </div>
                  </td>
                  <td>{{ props.item.AddressText }}</td>
                  <td>{{ props.item.Status }}</td>
                  <td>
                    <div style="width: 126px;">
                      <v-progress-linear
                        height="25"
                        :value="
                          Math.round(
                            ((props.item.TotalSpots -
                              props.item.AvailableSpots) /
                              props.item.TotalSpots) *
                              100,
                            1
                          )
                        "
                        reactive
                      >
                        <span class="subtitle secondary--text"
                          >{{
                            props.item.TotalSpots - props.item.AvailableSpots
                          }}
                          / {{ props.item.TotalSpots }}</span
                        >
                      </v-progress-linear>
                    </div>
                  </td>
                  <td>
                    <v-tooltip
                      v-if="
                        props.item.WithAdminRights ||
                          isGlobalAdmin ||
                          user.canEditAvailabilityTable
                      "
                      top
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          class="mr-2 secondary--text"
                          @click="$router.push(`/place/${props.item.Id}`)"
                          v-on="on"
                        >
                          <v-icon small>
                            mdi-pencil
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Edit place</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-if="
                            !props.item.ChildPlaces ||
                              props.item.ChildPlaces.length <= 0
                          "
                          :style="
                            user.isPlaceAdmin ||
                            user.isAdmin ||
                            user.hasOperatorRole
                              ? 'visibility: visible;'
                              : 'visibility: hidden;'
                          "
                          icon
                          small
                          class="mr-2"
                          @click="
                            $router.push({
                              name: 'gate-controllers',
                              params: { id: props.item.Id }
                            })
                          "
                          v-on="on"
                        >
                          <v-icon small>
                            mdi-select-inverse
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Gate controllers</span>
                    </v-tooltip>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          :style="
                            user.isPlaceAdmin
                              ? 'visibility: visible;'
                              : 'visibility: hidden;'
                          "
                          icon
                          small
                          class="mr-2"
                          v-on="on"
                          @click="
                            $router.push(`/monthly-passes/${props.item.Id}`)
                          "
                        >
                          <v-icon small>
                            mdi-calendar
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Monthly passes</span>
                    </v-tooltip>
                    <!-- <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            small
                            class="mr-2"
                            @click="$router.push(`/statistics/${item.Id}`)"
                            v-on="on"
                          >
                            <v-icon small>
                              mdi-chart-line
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Statistics</span>
                      </v-tooltip> -->
                    <v-icon
                      v-if="
                        props.item.WithAdminRights && props.item.ControllerDead
                      "
                      color="error"
                    >
                      mdi-alert
                    </v-icon>

                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          :style="
                            user.isPlaceAdmin || user.isAdmin
                              ? 'visibility: visible;'
                              : 'visibility: hidden;'
                          "
                          icon
                          small
                          class="mr-2"
                          @click="openCarWashDisputes(props.item)"
                          v-on="on"
                        >
                          <v-icon small>
                            mdi-file
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Disputes</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
              <!-- <template
                v-slot:item.data-table-expand="{ item, isExpanded, expand }"
              >
                <v-btn
                  v-if="
                    Array.isArray(item.ChildPlaces) &&
                      item.ChildPlaces.length > 0 &&
                      !isExpanded
                  "
                  icon
                  @click="expand(true)"
                >
                  <v-icon>mdi-menu-down</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    Array.isArray(item.ChildPlaces) &&
                      item.ChildPlaces.length > 0 &&
                      isExpanded
                  "
                  icon
                  @click="expand(false)"
                >
                  <v-icon>mdi-menu-up</v-icon>
                </v-btn>
              </template> -->
              <!-- <template v-slot:expanded-item="{ headers, item }">
                <td
                  v-if="
                    Array.isArray(item.ChildPlaces) &&
                      item.ChildPlaces.length > 0
                  "
                  :colspan="headers.length"
                >
                  <v-data-table
                    :items="item.ChildPlaces"
                    :headers="headers"
                    class="overflow-y-auto"
                    style="max-height: 60vh;"
                    hide-default-footer
                    hide-default-header
                    :items-per-page="-1"
                  >
                    <template v-slot:item.Name="props">
                      <td>
                        <div style="width: 260px;">
                          <v-tooltip v-if="props.item.WithAdminRights" bottom>
                            <template v-slot:activator="{ on }">
                              <div
                                v-if="props.item.WithAdminRights"
                                :class="{
                                  'primary--text': props.item.Type == 'PARKING',
                                  'purple--text': props.item.Type == 'CAR_WASH'
                                }"
                                class="d-inline mr-2"
                                v-on="on"
                              >
                                {{ props.item.Type === 'PARKING' ? 'P' : 'W' }}
                              </div>
                            </template>
                            <span> ID={{ props.item.Id }} </span>
                          </v-tooltip>
                          {{ props.item.Name }}
                        </div>
                      </td>
                    </template>
                    <template v-slot:item.occupancy="props">
                      <td>
                        <div style="width: 126px;">
                          <v-progress-linear
                            height="25"
                            :value="
                              Math.round(
                                ((props.item.TotalSpots -
                                  props.item.AvailableSpots) /
                                  props.item.TotalSpots) *
                                  100,
                                1
                              )
                            "
                            reactive
                          >
                            <span class="subtitle secondary--text"
                              >{{
                                props.item.TotalSpots -
                                  props.item.AvailableSpots
                              }}
                              / {{ props.item.TotalSpots }}</span
                            >
                          </v-progress-linear>
                        </div>
                      </td>
                    </template>
                    <template v-slot:item.actions="props">
                      <v-tooltip
                        v-if="props.item.WithAdminRights && isGlobalAdmin"
                        top
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            small
                            class="mr-2"
                            @click="$router.push(`/place/${props.item.Id}`)"
                            v-on="on"
                          >
                            <v-icon small>
                              mdi-pencil
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Edit place</span>
                      </v-tooltip>
                      <v-tooltip
                        v-if="props.item.WithAdminRights && isGlobalAdmin"
                        top
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            small
                            class="mr-2"
                            @click="
                              $router.push({
                                name: 'gate-controllers',
                                params: { id: props.item.Id }
                              })
                            "
                            v-on="on"
                          >
                            <v-icon small>
                              mdi-select-inverse
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Gate controllers</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            :style="
                              props.item.WithAdminRights &&
                              props.item.Operator === 'B' &&
                              user.isAdmin
                                ? 'visibility: visible;'
                                : 'visibility: hidden;'
                            "
                            icon
                            small
                            class="mr-2"
                            v-on="on"
                            @click="
                              $router.push(`/monthly-passes/${props.item.Id}`)
                            "
                          >
                            <v-icon small>
                              mdi-calendar
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Monthly passes</span>
                      </v-tooltip>
                      <v-icon
                        v-if="
                          props.item.WithAdminRights &&
                            props.item.ControllerDead
                        "
                        color="error"
                      >
                        mdi-alert
                      </v-icon>
                    </template>
                  </v-data-table>
                </td>
              </template> -->
            </v-data-table>
            <v-toolbar v-else class="elevation-0 mt-12">
              <v-spacer></v-spacer>
              <v-progress-circular
                indeterminate
                color="secondary"
              ></v-progress-circular>
              <v-spacer></v-spacer>
            </v-toolbar>
          </v-card-text>
        </v-card>
        <v-pagination
          v-if="places.length > 0"
          v-model="currentPageNumber"
          :length="pageNumbers"
          total-visible="15"
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          circle
          class="mt-4"
        ></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Dashboard',
  components: {
    Searchbar: () =>
      import(/* webpackChunkName: "Searchbar" */ '@/components/Searchbar')
  },
  data: () => ({
    rowsPerPage: 15,
    elementVisible: false,
    headers: [
      {
        text: 'Location',
        i18n: 'DASHBOARD.PLACES_TITLE',
        align: 'start',
        sortable: false,
        value: 'Name'
      },
      {
        text: 'Address',
        i18n: 'DASHBOARD.ADDRESS',
        align: 'start',
        sortable: false,
        value: 'AddressText'
      },
      {
        text: 'Status',
        i18n: 'DASHBOARD.STATUS',
        align: 'start',
        sortable: false,
        value: 'Status'
      },
      {
        text: 'Occupancy',
        align: 'start',
        sortable: false,
        value: 'occupancy'
      },
      { text: '', sortable: false, value: 'actions' }
    ],
    expanded: []
  }),
  computed: {
    ...mapGetters('app', ['searchString']),
    ...mapGetters('sessions', [
      'places',
      'filteredPlaces',
      'totalSpots',
      'availableSpots'
    ]),
    ...mapGetters('authentication', ['user', 'isGlobalAdmin']),
    currentPageNumber: {
      get() {
        return this.$store.state.app.currentPageNumber
      },
      set(val) {
        this.$store.commit('app/setCurrentPageNumber', val)
      }
    },
    pageNumbers() {
      return Math.floor(this.places.length / this.rowsPerPage)
    },
    paginatedData() {
      if (this.searchString.length) {
        return this.filteredPlaces
      }
      if (this.places.length <= this.rowsPerPage) {
        return this.filteredPlaces
      }
      const start = this.currentPageNumber * this.rowsPerPage
      const end = start + this.rowsPerPage
      return this.places.slice(start, end)
    },
    isChildItem(item) {
      return item.isChildPlace ? 'primary' : ''
    }
  },
  created() {
    this.$store.dispatch('sessions/getPlaces')
  },
  methods: {
    openCarWashDisputes(item) {
      this.$router.push({
        name: 'carWashDisputes',
        params: { placeId: item.Id }
      })
    }
  }
}
</script>
<style scoped>
::v-deep .v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: none !important;
}
</style>
